import { computed, ref } from 'vue';

export const useShipDate = () => {
  const shipFromDateOffset = 3;
  const shipEndDateOffset = 5;
  const toFromDateOffset = 10;
  const toEndDateOffset = 16;

  const placedDate = ref(dayjs().format('MMM DD'));

  const shipFromDate = ref(dayjs().add(shipFromDateOffset, 'day'));
  const shipEndDate = ref(dayjs().add(shipEndDateOffset, 'day'));

  const shipTime = computed(() => {
    if (shipFromDate.value.day() === 0) {
      shipFromDate.value = shipFromDate.value.add(1, 'day');
    }

    if (shipEndDate.value.day() === 0) {
      shipEndDate.value = shipEndDate.value.add(1, 'day');
    }

    const [startMonth, startDate, endMonth, endDate] = [
      shipFromDate.value.format('MMM'),
      shipFromDate.value.format('DD'),
      shipEndDate.value.format('MMM'),
      shipEndDate.value.format('DD'),
    ];

    return startMonth === endMonth
      ? `${startMonth} ${startDate} - ${endDate}`
      : `${startMonth} ${startDate} - ${endMonth} ${endDate}`;
  });

  const deliveredStartDate = ref(dayjs().add(toFromDateOffset, 'day'));
  const deliveredEndDate = ref(dayjs().add(toEndDateOffset, 'day'));

  const deliveredTime = computed(() => {
    if (0 === deliveredStartDate.value.day()) {
      deliveredStartDate.value = deliveredStartDate.value.add(1, 'day');
    }

    if (0 === deliveredEndDate.value.day()) {
      deliveredEndDate.value = deliveredEndDate.value.add(1, 'day');
    }

    const [startMonth, startDate, endMonth, endDate] = [
      deliveredStartDate.value.format('MMM'),
      deliveredStartDate.value.format('DD'),
      deliveredEndDate.value.format('MMM'),
      deliveredEndDate.value.format('DD'),
    ];

    if (startMonth === endMonth) {
      return `${startMonth} ${startDate} - ${endDate}`;
    } else {
      return `${startMonth} ${startDate} - ${endMonth} ${endDate}`;
    }
  });

  return {
    placedDate,
    shipTime,
    deliveredTime,
  };
};
